import { models } from 'powerbi-client';
import { Component, OnInit } from '@angular/core';
import { EmbedConfig } from 'src/app/core/models/analytics/embed-config';
import { PowerBIReport } from 'src/app/core/models/analytics/power-bi-report';
import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';

@Component({
  selector: 'app-impact-assessment-dashboard',
  templateUrl: './impact-assessment-dashboard.component.html',
  styleUrls: ['./impact-assessment-dashboard.component.scss']
})
export class ImpactAssessmentDashboardComponent implements OnInit {

  reportId: any;
  embedConfig: EmbedConfig;
  isLoading = false;
  powerBIReport = new PowerBIReport();
  options: models.ISettings = {
    filterPaneEnabled: false,
    navContentPaneEnabled: false
  };

  constructor(private analyticsService: AnalyticsService) {
    this.embedConfig = new EmbedConfig();
    this.reportId = 4;
    this.getReportById();
    this.getPowerBIReport();
  }

  ngOnInit(): void {
    this.powerBIReport = new PowerBIReport();
  }

  getReportById(): void {
    this.isLoading = true;
    this.analyticsService.getReportDetails(this.reportId)
      .subscribe((config: PowerBIReport) => {
        this.powerBIReport = config;
        this.isLoading = false;
      });
  }

  getPowerBIReport(): void {
    this.isLoading = true;
    this.analyticsService.getPowerBIReport(this.reportId)
      .subscribe((config: EmbedConfig) => {
        this.embedConfig = config;
        this.isLoading = false;
      });
  }

  onEmbedded(report: any): void {
    (report.element.childNodes[0] as HTMLElement).style.height = window.innerHeight - 210 + 'px';
  }
}
